import React, { Fragment } from 'react';
import createSvgIcon from '../createSvgIcon';

const AudioFile = () => {
  const Icon = createSvgIcon({
    title: 'AudioFile',
    width: '32px',
    height: '32px',
    viewBox: '0 0 32 32',
    content: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M25,27.31V29a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V3A1,1,0,0,1,6,2H20.59l4.7,4.71,1.42-1.42L21.41,0H6A3,3,0,0,0,3,3V29a3,3,0,0,0,3,3H24a3,3,0,0,0,3-3v-.47Z",
      fill: "#101010"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "23",
      y: "16",
      width: "7",
      height: "3",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("polygon", {
      points: "23 21.05 23 24.57 27.66 27.42 29.23 24.86 23 21.05",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("polygon", {
      points: "23 14.34 29.23 10.52 27.66 7.96 23 10.82 23 14.34",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14,13H9v9h5l4.45,3A1,1,0,0,0,20,24.13v-14a1,1,0,0,0-1.64-.77Z",
      fill: "none",
      stroke: "#101010",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }))
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

export default AudioFile;